import React from 'react';

const styles = {
  draft: { bg: 'rgba(100,116,139,0.1)', color: '#94a3b8', border: 'rgba(100,116,139,0.2)' },
  sent: { bg: 'rgba(59,130,246,0.1)', color: '#60a5fa', border: 'rgba(59,130,246,0.2)' },
  paid: { bg: 'rgba(16,185,129,0.1)', color: '#34d399', border: 'rgba(16,185,129,0.2)' },
  partial: { bg: 'rgba(250,204,21,0.12)', color: '#facc15', border: 'rgba(250,204,21,0.25)' },
  overdue: { bg: 'rgba(239,68,68,0.1)', color: '#f87171', border: 'rgba(239,68,68,0.2)' },
};

export default function StatusBadge({ status }) {
  const style = styles[status] || styles.draft;
  const label = status === 'sent' ? 'received' : status;
  return (
    <span style={{ padding: '0.25rem 0.5rem', fontSize: '0.75rem', fontWeight: 500, borderRadius: '0.375rem', border: `1px solid ${style.border}`, background: style.bg, color: style.color, textTransform: 'uppercase' }}>
      {label}
    </span>
  );
}
